import FormGroupInput from "./Inputs/formGroupInput.vue";
import FormAddress from "./Inputs/formAddress.vue";
import FormPhone from "./Inputs/formPhone.vue";
import EditInput from "./Inputs/editInput.vue";
import AssessmentQuestion from "./Inputs/formAssessmentQuestion.vue";
import AssessmentQuestionOption from "./Inputs/formAssessmentQuestionOption.vue";

import DropDown from "./Dropdown.vue";
import PaperTable from "./PaperTable.vue";
import Button from "./Button";

import Card from "./Cards/Card.vue";
import ChartCard from "./Cards/ChartCard.vue";
import StatsCard from "./Cards/StatsCard.vue";

import SidebarPlugin from "./SidebarPlugin/index";
import Multiselect from "vue-multiselect";

import Bar from "./Charts/Bar.vue";
import Pie from "./Charts/Pie.vue";

let components = {
  FormGroupInput,
  FormAddress,
  FormPhone,
  AssessmentQuestion,
  AssessmentQuestionOption,
  Card,
  ChartCard,
  StatsCard,
  PaperTable,
  DropDown,
  SidebarPlugin,
  EditInput,
  Multiselect,
  Bar,
  Pie
};

export default components;

export {
  FormGroupInput,
  FormAddress,
  FormPhone,
  AssessmentQuestion,
  AssessmentQuestionOption,
  Card,
  ChartCard,
  StatsCard,
  PaperTable,
  DropDown,
  Button,
  SidebarPlugin,
  EditInput,
  Multiselect,
  Bar,
  Pie
};
